import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Icon } from "semantic-ui-react";
import DatePicker from "react-datepicker/dist/react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CampaignDisclosureDateModal.less";

const CampaignDisclosureDateModal = ({
  open,
  onCancel,
  onContinue,
  title = "Campaign Disclosures - Started"
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleContinue = () => {
    if (startDate && endDate && onContinue) {
      onContinue(startDate, endDate);
    }
  };

  const handleCancel = () => {
    // Reset dates when cancelled
    setStartDate(null);
    setEndDate(null);
    if (onCancel) {
      onCancel();
    }
  };

  const isValidDateRange = () => {
    return startDate && endDate && startDate <= endDate;
  };

  return (
    <Modal open={open} onClose={handleCancel} dimmer="inverted" size="small">
      <Modal.Header className="ui header">
        <Icon name="calendar alternate outline" />
        {title}
      </Modal.Header>

      <Modal.Content>
        <div className="campaign-disclosure-date-content">
            <p>
              {title === "Campaign Disclosures - Not Started"
                ? "Select the date range for campaign disclosures that have not been initiated:"
                : "Select the date range for campaign disclosures that have been initiated:"}
            </p>

          <div className="date-picker-row">
            <div className="date-picker-field">
              <label>Campaign Start Date:</label>
              <div className="date-picker-with-icon">
                <div className="date-picker-icon">
                  <Icon name="calendar alternate outline" />
                </div>
                <div className="date-picker-alignment">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    placeholderText="Select start date"
                    dateFormat="MM/dd/yyyy"
                    maxDate={endDate || new Date()}
                  />
                </div>
              </div>
            </div>

            <div className="date-picker-field">
              <label>Campaign End Date:</label>
              <div className="date-picker-with-icon">
                <div className="date-picker-icon">
                  <Icon name="calendar alternate outline" />
                </div>
                <div className="date-picker-alignment">
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    placeholderText="Select end date"
                    dateFormat="MM/dd/yyyy"
                    minDate={startDate}
                  />
                </div>
              </div>
            </div>
          </div>

          {startDate && endDate && startDate > endDate && (
            <div className="error-message">
              <Icon name="exclamation triangle" color="red" />
              End date must be after start date
            </div>
          )}
        </div>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button primary disabled={!isValidDateRange()} onClick={handleContinue}>
          Continue
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

CampaignDisclosureDateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  title: PropTypes.string
};

export default CampaignDisclosureDateModal;
